import { requireSupabase } from '../lib/supabase';

export async function getAdminUsers() {
  const { data, error } = await requireSupabase().rpc('admin_list_users');
  if (error) throw error;
  return data || [];
}

export async function updateAdminUserAccess({ userId, systemRole, professionalRole }) {
  const { error } = await requireSupabase().rpc('admin_update_user_access', {
    target_user_id: userId,
    target_system_role: systemRole,
    target_professional_role: professionalRole || null,
  });
  if (error) throw error;
}
